// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2BZ58","radioRow":"SimpleQuestionBuilderModal_radioRow__1vatC"};